import React from "react"
import styled from 'styled-components'
import { useTrail, animated as a } from 'react-spring'
import { concept1, concept2, concept3, concept4 } from '../../images/concept'

const LoadingPage = styled(Trail)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

const ConceptLine = styled(a.div)`
  width: 24.0rem;
  & + & {
    margin-top: 4.0rem;
  }
  img {
    display: block;
    width: 100%;
    height: auto;
  }
`

function Trail({ open, children, ...props }) {
  const items = React.Children.toArray(children)
  const trail = useTrail(items.length, {
    config: { mass: 5, tension: 1000, friction: 200 },
    opacity: open ? 1 : 0,
    x: open ? 0 : -40,
    from: { opacity: 0, x: -40 },
  })
  return (
    <div {...props}>
      {trail.map(({ x, ...rest }, index) => (
        <ConceptLine
          key={index}
          // className="trails-text"
          style={{ ...rest, transform: x.interpolate((x) => `translate3d(${x}px, 0, 0)`) }}>
          {items[index]}
        </ConceptLine>
      ))}
    </div>
  )
}

const Loading = () => {

  return (
    <LoadingPage open={true}>
      <img src={concept1} alt='わたしたちは' />
      <img src={concept2} alt='出逢い、見つめ、創り出す。' />
      <img src={concept3} alt='日々を重ね、区切り、別れる。' />
      <img src={concept4} alt='つくり、つづり、つづく。' />
      {/* <p>わたしたちは</p>
      <p>出逢い、見つめ、創り出す。</p>
      <p>日々を重ね、区切り、別れる。</p>
      <p>つくり、つづり、つづく。</p> */}
    </LoadingPage>
  )
}

export default Loading